import { Skeleton } from '@material-ui/lab';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { useStyles } from './useStyles';

export const EditorSkeleton = ({ className }) => {
  const styles = useStyles();

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.row}>
        <Skeleton
          className={styles.rect}
          variant="rect"
        />
      </div>

      <div className={styles.row}>
        <Skeleton
          className={styles.rectSmall}
          variant="rect"
        />
      </div>

      <div className={styles.row}>
        <Skeleton
          className={styles.rectMedium}
          variant="rect"
        />
      </div>
    </div>
  );
};

EditorSkeleton.propTypes = {
  className: PropTypes.string,
};

EditorSkeleton.defaultProps = {
  className: '',
};
